export default __webpack_public_path__ + "static/media/myReferralIcon.55f76a5a.svg";